import styled from '@emotion/styled';
import shouldForwardProp from '@styled-system/should-forward-prop';
import PropTypes from 'prop-types';
import {
  border,
  flexbox,
  layout,
  position,
  space,
  system,
  variant,
} from 'styled-system';

import { deprecated } from '../../internal/propTypeValidators';
import sx from '../../internal/styles/sx';
import type { BoxProps } from './types';

const Box = styled('div', {
  shouldForwardProp,
})<BoxProps>(
  {
    boxSizing: 'border-box',
    minWidth: 0,
  },
  layout,
  space,
  flexbox,
  position,
  border,
  system({
    overflowWrap: true,
    cursor: true,
    userSelect: true,
  }),
  system({
    backgroundColor: {
      property: 'backgroundColor',
      scale: 'colors.text',
    },
  }),
  variant({
    prop: 'scrollbar',
    variants: {
      primary: {
        '::-webkit-scrollbar-track': {
          backgroundColor: 'neutral.20',
          borderRadius: 1,
        },
        '::-webkit-scrollbar': {
          width: '7px',
          height: '7px',
        },
        '::-webkit-scrollbar-thumb': {
          borderRadius: 1,
          backgroundColor: 'primary.50',
        },
      },
      hidden: {
        '::-webkit-scrollbar': {
          display: 'none',
        },
      },
    },
  }),
  sx
);

Box.propTypes = {
  color: deprecated(PropTypes.oneOf(['white', 'brandedBg', 'emphasis'])),
};

export default Box;
